import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  console.log('componentDefaultValue', componentDefaultValue);
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    searchParameter['moduleId'] = parameter;
    sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
  }
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    defaultFormData['moduleId'] = parameter;
  }
  pageComponent.setState({ defaultFormData });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

//通过 Favorite 修改 icon
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Favorite) {
      //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
      iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  return data;
}

export function formatGroupData({ parameter, sectionComponent } = {}) {
  let data = parameter.map((item, i) => {
    let dataItem = item.DataList.map((item, i) => {
      let iconFormat = [];
      if (item.Favorite) {
        //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
        iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
      }
      if (iconFormat.length > 0) item.IconFormat = iconFormat;
      return item;
    })
    item.DataList = dataItem
  })
  return data;
}

//更新 Favorite 状态
export function updateFavorite({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .put('Admin/CompanyEmailTemplate/UpdateFavorite', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addCompanyEmailTemplatePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie });
}

export function editCompanyEmailTemplatePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie });
}

function setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let options = [];
  sectionComponent.child?.current?.state.data.map((item, i) => {
    if (item.key !== 0) {
      options.push({ label: item.Name, value: item.Name });
    }
  })

  setTimeout(() => {
    let componentDataSource = { ...sectionComponent.customForm.current.state.componentDataSource };
    componentDataSource['GroupName'] = options;
    sectionComponent.customForm.current.setState({ componentDataSource });
  }, config.setTimeoutMilliSecond);
}